var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCategoryIcon = function SvgCategoryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 15 15",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.302 5.233V2.585c0-.823-.373-1.155-1.3-1.155H9.644c-.928 0-1.301.332-1.301 1.155v2.642c0 .829.373 1.155 1.3 1.155h2.357c.928.006 1.301-.326 1.301-1.149zM13.302 11.794V9.438c0-.928-.373-1.301-1.3-1.301H9.644c-.928 0-1.301.373-1.301 1.3v2.357c0 .928.373 1.301 1.3 1.301h2.357c.928 0 1.301-.373 1.301-1.3zM6.595 5.233V2.585c0-.823-.373-1.155-1.3-1.155H2.937c-.928 0-1.301.332-1.301 1.155v2.642c0 .829.373 1.155 1.3 1.155h2.357c.928.006 1.301-.326 1.301-1.149zM6.595 11.794V9.438c0-.928-.373-1.301-1.3-1.301H2.937c-.928 0-1.301.373-1.301 1.3v2.357c0 .928.373 1.301 1.3 1.301h2.357c.928 0 1.301-.373 1.301-1.3z",
    stroke: "#424242",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default __webpack_public_path__ + "static/media/CategoryIcon.45e5453e.svg";
export { SvgCategoryIcon as ReactComponent };